import type { ReactElement } from 'react';

import { useTheme } from '@emotion/react';

import { CheckmarkFilledIcon } from '@twistopayments/design-system/icons/inline';

import { ActionContent } from './../action';
import * as styles from './action-checkbox.styles';

type Props = {
  label: ReactElement | string;
  subLabel?: ReactElement | string;
  icon: ReactElement;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  endAdornment?: ReactElement;
};

export const ActionCheckbox = ({
  label,
  subLabel,
  icon,
  isChecked,
  onClick,
  disabled = false,
  className,
  endAdornment,
  ...rest
}: Props) => {
  const theme = useTheme();

  return (
    <label
      className={className}
      css={[styles.root(theme), !disabled && styles.clickable(theme), disabled && styles.disabled]}
      data-testid="action-checkbox"
      {...rest}>
      <ActionContent
        caption={label}
        disabled={disabled}
        endAdornment={endAdornment}
        icon={isChecked ? <CheckmarkFilledIcon color="primary" /> : icon}
        label={subLabel}
      />

      <input
        readOnly
        checked={isChecked}
        css={styles.shadowInput}
        disabled={disabled}
        type="checkbox"
        onClick={onClick}
      />
    </label>
  );
};
